/* eslint-disable no-console */
import {
  cbamSection1ExporterAndInstallationProfileQuestions,
  cbamSection2ActivityDataAndProductionSystemBoundaryQuestions,
  cbamSection3DirectEmbeddedEmissionsScope1Questions,
  cbamSection4IndirectEmbeddedEmissionsElectricityQuestions,
  cbamSection5PrecursorEmissionsQuestions,
  cbamSection6MethodologyDataQualityVerificationQuestions,
  cbamSection7EmissionSummaryAndExportSpecificOutputQuestions
} from './cbam/cbamObj';
import {
  cbamSection1IronAndSteelPlantAndProductionInformationQuestions,
  cbamSection2IronAndSteelSourceStreamAndDirectEmissionsDataQuestions,
  cbamSection3IronAndSteelElectricityAndIndirectEmissionsQuestions,
  cbamSection4IronAndSteelProcessLevelProductionAndEmissionsDataQuestions,
  cbamSection5IronAndSteelPrecursorPurchasedInputEmissionsDataQuestions,
  cbamSection6IronAndSteelCarbonPricingAndTaxAdjustmentQuestions,
  cbamSection7IronAndSteelShipmentAndCustomsInformationQuestions
} from './cbam/IronandSteel/ironandSteelObj';
import {
  corporateDisclosureTabQuestions,
  corporateEnvironmentalPerformanceBiodiversityTabQuestions,
  corporateEnvironmentalPerformanceFinancialServicesTabQuestions,
  corporateEnvironmentalPerformanceForestsTabQuestions,
  corporateEnvironmentalPerformancePlasticsTabQuestions,
  corporateEnvironmentalPerformanceWaterSecurityTabQuestions,
  corporateFurtherInformationAndSignOffTabQuestions,
  corporateGovernanceTabQuestions,
  corporateIntroTabQuestions,
  corporateManagementTabQuestions,
  corporatePerformanceClimateChangeTabQuestions,
  corporatePerformanceConsolidationApproachTabQuestions,
  corporateStrategyTabQuestions
} from './cdp/corporate/corporateObj';
import {
  smeBusinessStrategyTabQuestions,
  smeDisclosureTabQuestions,
  smeGovernanceTabQuestions,
  smeIntroTabQuestions,
  smeManagementTabQuestions,
  smePerformanceClimateChangeTabQuestions,
  smePerformanceConsolidationApproachTabQuestions,
  smeSignOffTabQuestions
} from './cdp/sme/smeObj';
import {environmental} from './environmental/envObj';
import {
  cbamIronAndSteelSubCategories,
  frameworkRoute,
  pillarRoutes,
  subCategoryConstants
} from './frameworkRoutes';
import {general} from './general/generalObj';
import {generalDisclosure} from './generalDisclosure/generalDisclosureObj';
import {governance} from './governance/governanceObj';
import {managementAndprocessDisclosure} from './managementAndProcessDisclosures/managementAndProcessDisclosuresObj';
import {principleWisePerformanceDisclosure} from './principleWisePerformanceDisclosure/principleWisePerformanceDisclosureObj';
import {realEstateObj} from './realEstate/realEstateObj';
import {social} from './social/socialObj';
import {
  autoMobileGovernance,
  autoMobileMetricsTargets,
  autoMobileRiskManagement,
  autoMobileStrategy
} from './tcfd/autoMobile/autoMobileObj';
import {
  generalGovernance,
  generalMetricsTargets,
  generalRiskManagement,
  generalStrategy
} from './tcfd/general/generalObj';
import {
  realEstateGovernance,
  realEstateMetricsTargets,
  realEstateRiskManagement,
  realEstateStrategy
} from './tcfd/realEstate/realEstateObj';

export const returnQuestions: (
  framework: string | undefined,
  pillar: string | undefined,
  setPillarObj: React.Dispatch<any>,
  subCategory?: number
) => void = (framework, pillar, setPillarObj, subCategory = 0) => {
  switch (framework) {
    case frameworkRoute.GRI:
      switch (pillar) {
        case pillarRoutes.GENERAL:
          setPillarObj(general);
          break;
        case pillarRoutes.ENV:
          setPillarObj(environmental);
          break;
        case pillarRoutes.SOCIAL:
          setPillarObj(social);
          break;
        case pillarRoutes.GOV:
          setPillarObj(governance);
          break;
        default:
          setPillarObj(undefined);
      }
      break;
    case frameworkRoute.BRSR:
      switch (pillar) {
        case pillarRoutes.SECTIONA:
          setPillarObj(generalDisclosure);
          break;
        case pillarRoutes.SECTIONB:
          setPillarObj(managementAndprocessDisclosure);
          break;
        case pillarRoutes.SECTIONC:
          setPillarObj(principleWisePerformanceDisclosure);
          break;
        default:
          setPillarObj(undefined);
      }
      break;
    case frameworkRoute.TCFD:
      if (subCategory === 2) {
        switch (pillar) {
          case pillarRoutes.GOV:
            setPillarObj(realEstateGovernance);
            break;
          case pillarRoutes.STARTEGY:
            setPillarObj(realEstateStrategy);
            break;
          case pillarRoutes.RISK_MANAGEMENT:
            setPillarObj(realEstateRiskManagement);
            break;
          case pillarRoutes.MATRICS_TARGETS:
            setPillarObj(realEstateMetricsTargets);
            break;
          default:
            setPillarObj(undefined);
        }
      } else if (subCategory === 5) {
        switch (pillar) {
          case pillarRoutes.GOV:
            setPillarObj(autoMobileGovernance);
            break;
          case pillarRoutes.STARTEGY:
            setPillarObj(autoMobileStrategy);
            break;
          case pillarRoutes.RISK_MANAGEMENT:
            setPillarObj(autoMobileRiskManagement);
            break;
          case pillarRoutes.MATRICS_TARGETS:
            setPillarObj(autoMobileMetricsTargets);
            break;
          default:
            setPillarObj(undefined);
        }
      } else {
        switch (pillar) {
          case pillarRoutes.GOV:
            setPillarObj(generalGovernance);
            break;
          case pillarRoutes.STARTEGY:
            setPillarObj(generalStrategy);
            break;
          case pillarRoutes.RISK_MANAGEMENT:
            setPillarObj(generalRiskManagement);
            break;
          case pillarRoutes.MATRICS_TARGETS:
            setPillarObj(generalMetricsTargets);
            break;
          default:
            setPillarObj(undefined);
        }
      }
      break;
    case frameworkRoute.SASB:
      switch (pillar) {
        case pillarRoutes.REAL_ESTATE:
          setPillarObj(realEstateObj);
          break;
        default:
          setPillarObj(undefined);
      }
      break;
    case frameworkRoute.CDP_SME:
      switch (pillar) {
        case pillarRoutes.SME_INTRODUCTION:
          setPillarObj(smeIntroTabQuestions);
          break;
        case pillarRoutes.SME_MANAGEMENT:
          setPillarObj(smeManagementTabQuestions);
          break;
        case pillarRoutes.SME_DISCLOSURE:
          setPillarObj(smeDisclosureTabQuestions);
          break;
        case pillarRoutes.SME_GOVERNANCE:
          setPillarObj(smeGovernanceTabQuestions);
          break;
        case pillarRoutes.BUSINESS_STRATEGY:
          setPillarObj(smeBusinessStrategyTabQuestions);
          break;
        case pillarRoutes.PERFORMANCE_CONSOLIDATION_APPROACH:
          setPillarObj(smePerformanceConsolidationApproachTabQuestions);
          break;
        case pillarRoutes.PERFORMANCE_CLIMATE_CHANGE:
          setPillarObj(smePerformanceClimateChangeTabQuestions);
          break;
        case pillarRoutes.SME_SIGN_OFF:
          setPillarObj(smeSignOffTabQuestions);
          break;
        default:
          setPillarObj(undefined);
      }
      break;
    case frameworkRoute.CDP_CORPORATE:
      switch (pillar) {
        case pillarRoutes.CORPORATE_INTRODUCTION:
          setPillarObj(corporateIntroTabQuestions);
          break;
        case pillarRoutes.CORPORATE_MANAGEMENT:
          setPillarObj(corporateManagementTabQuestions);
          break;
        case pillarRoutes.CORPORATE_DISCLOSURE:
          setPillarObj(corporateDisclosureTabQuestions);
          break;
        case pillarRoutes.CORPORATE_GOVERNANCE:
          setPillarObj(corporateGovernanceTabQuestions);
          break;
        case pillarRoutes.CORPORATE_STRATEGY:
          setPillarObj(corporateStrategyTabQuestions);
          break;
        case pillarRoutes.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH:
          setPillarObj(corporatePerformanceConsolidationApproachTabQuestions);
          break;
        case pillarRoutes.CORPORATE_PERFORMANCE_CLIMATE_CHANGE:
          setPillarObj(corporatePerformanceClimateChangeTabQuestions);
          break;
        case pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_FORESTS:
          setPillarObj(corporateEnvironmentalPerformanceForestsTabQuestions);
          break;
        case pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_WATER_SECURITY:
          setPillarObj(
            corporateEnvironmentalPerformanceWaterSecurityTabQuestions
          );
          break;
        case pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_PLASTICS:
          setPillarObj(corporateEnvironmentalPerformancePlasticsTabQuestions);
          break;
        case pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_BIO_DIVERSITY:
          setPillarObj(
            corporateEnvironmentalPerformanceBiodiversityTabQuestions
          );
          break;
        case pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_FINANCIAL_SERVICES:
          setPillarObj(
            corporateEnvironmentalPerformanceFinancialServicesTabQuestions
          );
          break;
        case pillarRoutes.CORPORATE_FURTHER_INFORMATION_AND_SIGN_OFF:
          setPillarObj(corporateFurtherInformationAndSignOffTabQuestions);
          break;
        default:
          setPillarObj(undefined);
      }
      break;
    case frameworkRoute.CBAM:
      if (cbamIronAndSteelSubCategories.includes(subCategory)) {
        switch (pillar) {
          case pillarRoutes.SECTION_1_PLANT_AND_PRODUCTION_INFORMATION:
            setPillarObj(
              cbamSection1IronAndSteelPlantAndProductionInformationQuestions
            );
            break;
          case pillarRoutes.SECTION_2_SOURCE_STREAM_AND_DIRECT_EMISSIONS_DATA:
            setPillarObj(
              cbamSection2IronAndSteelSourceStreamAndDirectEmissionsDataQuestions
            );
            break;
          case pillarRoutes.SECTION_3_ELECTRICITY_AND_INDIRECT_EMISSIONS:
            setPillarObj(
              cbamSection3IronAndSteelElectricityAndIndirectEmissionsQuestions
            );
            break;
          case pillarRoutes.SECTION_4_PROCESS_LEVEL_PRODUCTION_AND_EMISSIONS_DATA:
            setPillarObj(
              cbamSection4IronAndSteelProcessLevelProductionAndEmissionsDataQuestions
            );
            break;
          case pillarRoutes.SECTION_5_PRECURSOR_PURCHASED_INPUT_EMISSIONS_DATA:
            setPillarObj(
              cbamSection5IronAndSteelPrecursorPurchasedInputEmissionsDataQuestions
            );
            break;
          case pillarRoutes.SECTION_6_CARBON_PRICING_AND_TAX_ADJUSTMENT:
            setPillarObj(
              cbamSection6IronAndSteelCarbonPricingAndTaxAdjustmentQuestions
            );
            break;
          case pillarRoutes.SECTION_7_SHIPMENT_AND_CUSTOMS_INFORMATION:
            setPillarObj(
              cbamSection7IronAndSteelShipmentAndCustomsInformationQuestions
            );
            break;
          default:
            setPillarObj(undefined);
        }
      }
      if (subCategory === subCategoryConstants.CEMENT_SUB_CATEGORY) {
        switch (pillar) {
          case pillarRoutes.SECTION_1_EXPORTER_AND_INSTALLATION_PROFILE:
            setPillarObj(cbamSection1ExporterAndInstallationProfileQuestions);
            break;
          case pillarRoutes.SECTION_2_ACTIVITY_DATA_AND_PRODUCTION_SYSTEM_BOUNDARY:
            setPillarObj(
              cbamSection2ActivityDataAndProductionSystemBoundaryQuestions
            );
            break;
          case pillarRoutes.SECTION_3_DIRECT_EMBEDDED_EMISSIONS_SCOPE_1:
            setPillarObj(cbamSection3DirectEmbeddedEmissionsScope1Questions);
            break;
          case pillarRoutes.SECTION_4_INDIRECT_EMBEDDED_EMISSIONS_ELECTRICITY:
            setPillarObj(
              cbamSection4IndirectEmbeddedEmissionsElectricityQuestions
            );
            break;
          case pillarRoutes.SECTION_5_PRECURSOR_EMISSIONS:
            setPillarObj(cbamSection5PrecursorEmissionsQuestions);
            break;
          case pillarRoutes.SECTION_6_METHODOLOGY_DATA_QUALITY_VERIFICATION:
            setPillarObj(
              cbamSection6MethodologyDataQualityVerificationQuestions
            );
            break;
          case pillarRoutes.SECTION_7_EMISSION_SUMMARY_AND_EXPORT_SPECIFIC_OUTPUT:
            setPillarObj(
              cbamSection7EmissionSummaryAndExportSpecificOutputQuestions
            );
            break;
          default:
            setPillarObj(undefined);
        }
      }
      break;
    default:
      setPillarObj(undefined);
  }
};
